import React, {useContext} from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import { PrivateRouteProps } from "../utils/Type";

const PrivateRoute: React.FC<PrivateRouteProps> = ({ allowedRoles }) => {
    const auth = useContext(AuthContext);
    const role = auth?.role;

    if(!role || !allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />
};

export default PrivateRoute;